import React from 'react'
import { Controller } from 'react-hook-form'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'

const Activated: React.FC = () => {
    const { control } = useFormContextUser()

    return (
        <Controller
            control={control}
            name="activated"
            render={({ field }) => (
                <UserFormField
                    variant="switch"
                    checked={Boolean(field.value)}
                    name={field.name}
                    onChange={(e) => field.onChange(e)}
                    switchLabel={field.value ? 'Compte activé' : 'Compte désactivé'}
                    dataCyScope="UserField"
                />
            )}
        />
    )
}

export default Activated
